import { isNil } from 'lodash-es';

/**
 * Full documentation:
 * https://code.aptitude.com/aptitude-source/aptitude/wikis/component-svgIcon
 *
 * TODO: implement supplemental service for using short-cut identifiers for resource paths
 * perhaps something like a filter path="iconSet:plus | svgPaths" that searches through a Constants or Values service
 */
export const SvgIconComponent = {
  bindings: {
    symbol: '@',
    path: '@',
    autoStyle: '<'
  },
  controller: class {
    symbol: string;
    path: string;
    autoStyle: boolean;

    href: string;
    styles: {};

    constructor(private $element) {
      'ngInject';
    }

    $onInit() {
      if (isNil(this.autoStyle)) {
        this.autoStyle = true;
      }
    }

    $onChanges(changes) {
      this.updateHref();
      this.updateStyles();
    }

    updateHref() {
      let val = '';
      if (this.symbol) {
        val = 'icons.svg#' + this.symbol;
      } else if (this.path) {
        val = this.path;
      }

      this.href = val;
    }

    updateStyles() {
      // allow autostyle to be optional
      // on by default
      if (this.autoStyle) {
        let val = { fill: '', width: '', height: '' };

        // Get svg element withing the context of this component.
        let element = $('svg', this.$element);

        // Get the size of text at this point.
        let fontSize = element.css('font-size');

        // Get the CSS styling for the SVG element inside the component.
        let height = element.css('height');
        let width = element.css('width');
        let fill = element.css('fill');

        // If it looks like we've got the default fill color of black,
        // use the current text color.
        if (fill === 'rgb(0, 0, 0)') {
          val.fill = 'currentcolor';
        }

        // If it looks like we've got the default size for SVG elements,
        // use the size of the current text as both height and width.
        if (height === '150px' && width === '300px') {
          val.height = fontSize;
          val.width = fontSize;
        }

        this.styles = val;
      }
    }
  },

  // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/xlink:href
  // xlink:href has been deprecated but Firefox in Windows still requires it
  // and all other browsers still support it - (except IE of course)
  template:
    '<svg ng-style="$ctrl.styles"> <use xlink:href="{{$ctrl.href}}"></use> </svg>'
};
